import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { ArrowLeftIcon } from "ui/gluestack/icon";
import { useRouter } from "expo-router";

interface Props {
  path: string;
}

export default function GoBack({ path }: Props) {
  const router = useRouter();

  return (
    <Button
      size="sm"
      variant="link"
      onPress={() => router.replace(path)}
      className="px-2 lg:px-0"
    >
      <ButtonIcon as={ArrowLeftIcon} />
      <ButtonText>Back</ButtonText>
    </Button>
  );
}
